const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AIGenerationTypeCommandURL: any = {
    PostAIGenerationType: Backofficebff + '/v1/ai-generation-types',
    PutAIGenerationType: Backofficebff + '/v1/ai-generation-types',
    DeleteAIGenerationType: Backofficebff + '/v1/ai-generation-types',
};

